import React from 'react';
import styled from 'styled-components';
import { FaComment } from 'react-icons/fa';
import { useMessages } from '../../contexts/MessageContext';
import { Link } from 'react-router-dom';

const BadgeContainer = styled.div`
  position: relative;
  display: inline-flex;
  margin-right: 16px;
`;

const IconButton = styled(Link)`
  position: relative;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text};
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
  
  &:focus {
    outline: none;
  }
`;

const NotificationBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transform: translate(30%, -30%);
  z-index: 5;
`;

const MessageBadge = ({ redirectPath }) => {
  const { unreadCount } = useMessages();
  
  // Default redirect path if not provided
  const path = redirectPath || '/partner/messages';
  
  console.log('MessageBadge rendering with unreadCount:', unreadCount);
  
  return (
    <BadgeContainer>
      <IconButton to={path} aria-label="Messages">
        <FaComment />
        {unreadCount > 0 && <NotificationBadge>{unreadCount}</NotificationBadge>}
      </IconButton>
    </BadgeContainer>
  );
};

export default MessageBadge; 